import axios from "axios";
import authHeader from "../auth-header";
import { PROTOCOL, URL } from "../../utils/constants";

const API_URL = `${PROTOCOL}://${URL}/okapi/mibui`;

export const getTolls = async (year) => {
  try {
    const response = await axios.get(`${API_URL}/tolls/${year}`, {
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching tolls:", error);
    throw error;
  }
};

export const editTolls = async (tolls) => {
  try {
    const response = await axios.put(`${API_URL}/tolls`, tolls, {
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error editing tolls:", error);
    throw error;
  }
};

// Crea entradas de peaje nuevas (rutas sin datos previos en el año seleccionado).
// MIBCORRPU-8: necesario para que tablas sin flujos asignados puedan recibir peajes.
export const createTollEntries = async (tolls) => {
  try {
    const response = await axios.post(`${API_URL}/tolls`, tolls, {
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error creating tolls:", error);
    throw error;
  }
};
